import type { PrimaryLanguage } from 'entities/languages'
import type { LocationLanguage } from 'lib/tolgee'

export const LANGUAGE_FROM_TOLGEE = {
  en: 'eng',
  es: 'spa',
  'pt-BR': 'por',
} satisfies Record<LocationLanguage, PrimaryLanguage>

/** Tolgee language → dayjs locale code (the matching `dayjs/locale/*` are imported at bootstrap). */
export const DAYJS_LOCALE_FROM_TOLGEE = {
  en: 'en',
  es: 'es',
  'pt-BR': 'pt-br',
} satisfies Record<LocationLanguage, string>
